import config from 'config'
import querystring from 'query-string'

// eslint-disable-next-line import/prefer-default-export
export const extractHostname = (url) => {
  if (!url) {
    return 'undefined'
  }

  const parts = url.split('//')
  const [noPort] = parts[parts.length - 1].split(':')
  const [noParam] = noPort.split('?')
  const [hostname] = noParam.split('/')

  return hostname
}

export const containsHostname = (host, urlString) => {
  if (!urlString) {
    return false
  }

  try {
    return new URL(urlString)?.hostname?.includes(host)
  } catch (err) {
    console.error('[containsHostname function error]: ', { host, urlString }, err)
    return false
  }
}

export const getConversionUrl = (path, params = {}) => {
  const queryString = Object.keys(params)
    .filter((k) => params[k])
    .map((k) => `${k}=${encodeURIComponent(params[k])}`)
    .join('&')

  if (path.indexOf('?') >= 0) {
    return `${config.credibleRoot}${path}${queryString && '&'}${queryString}`
  }

  return `${config.credibleRoot}${path}${queryString && '?'}${queryString}`
}

/**
  All widgets must have the same url structure
  /partners-widgets/:marketplace/:widgetType/

  (React Router is not being used here on purpose,
  now each widget has it own entry point)
*/
export const getRouteParams = (pathname) => {
  const parts = pathname.split('/').filter(Boolean)

  if (parts.length < 2) {
    return {}
  }

  return {
    marketplace: parts[parts.length - 2],
    widgetType: parts[parts.length - 1],
  }
}

export const addTrackingParamsToUrl = ({ widgetContext, lenderSlug, url }) => {
  const { partnersPreferredLender } = widgetContext || {}
  const { query, url: parsedUrl } = querystring.parseUrl(url)
  const trackingParams = {
    ...query,
    preferred_lender: partnersPreferredLender || lenderSlug,
  }
  const trackingParamsStr = querystring.stringify(trackingParams)

  return trackingParamsStr ? `${parsedUrl}?${trackingParamsStr}` : parsedUrl
}

export function getQueryParamFromUrl(paramName, search, isBoolean = false) {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(search || window.location.search)
    const param = params.get(paramName)

    return isBoolean ? param === 'true' : param
  }

  return undefined
}
